
export class Question{
 
    PreguntaId;
    PreguntaIdPadre;
    PreguntaNro;
    PreguntaObligatoria;
    PreguntaOrden;
    PreguntaTexto;
    PreguntasMaxCaracteres;
    response;

}